(function()
{
	"use strict";

	function MeasureLine(engine)
	{
		this.Container_constructor();
		this.mouseEnabled = false;
		this.width = cm.app.display.width / 2;
		this.dashArray = [];
		this.name = "MeasureLine";
		this.engine = engine;
		this.sensor = null;
		this.isSensing = false;
		this.dashedLine =  new cjs.Sprite(cm.Assets.lib.gameSS, "measure-line").set({x:95}).center();
		this.addChild(this.dashedLine);
		this.addPhysicsSensor();
		this.posCollection = null;
	}

	var p = createjs.extend(MeasureLine, cjs.Container);

	p.addPhysicsSensor = function()
	{
		this.sensor = new cm.MeasureLineBox2d(this.engine, -this.width+160, -330, this, "measure-line");
	};

	p.triggerSensor = function()
	{
		var pos = this.sensor.body.GetPosition();
		pos.y = pos.y + 0.5;
		this.posCollection = pos;
		this.sensor.body.SetPosition(pos);
	};

	p.stopSensing = function()
	{
		this.isSensing = false;

	};


	p._tick = function(e)
	{
		this.Container__tick(e);

		if(this.isSensing){
			this.triggerSensor();
		}
		else{
			var pos = this.sensor.body.GetPosition();
			pos.y = -20;
			this.sensor.body.SetPosition(pos);
		}

	};

	cm.MeasureLine = cjs.promote(MeasureLine, "Container");
})();
